<div>
  <input class="form-control"
    type="text"
    [formControl]="inputControl"
    [placeholder]="placeholder"
    [class.ng-invalid]="invalid || inputControl.invalid">
  </div>

  @if (inputControl.invalid && inputControl.touched) {
    <div class="pt-2 text-danger">
      @if (inputControl.hasError('pattern') || inputControl.hasError('email')) {
        <p [innerHTML]="'form.invalidEmail' | translate"></p>
      }
    </div>
  }
